import { ChangeDetectorRef, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { MatDialog } from "@angular/material/dialog";
import { ViewerConfigurationService } from "../../viewer-components/services/viewer-configuration.service";

export abstract class BaseLayerComponent {
  protected readonly cdr = inject(ChangeDetectorRef);

  protected constructor(
    protected http: HttpClient,
    protected viewerConfigurationService: ViewerConfigurationService,
    protected matDialog: MatDialog,
  ) {}

  abstract getCapabilitiesSuccess(data: Object);

  abstract getCapabilitiesError();

  getCapabilities(url, credentials) {
    let headers = {};
    if (credentials) {
      headers = {
        Authorization: `Basic ${window.btoa(credentials)}`,
      };
    }
    this.http
      .get(url, {
        responseType: "text",
        headers,
      })
      .subscribe(
        (res) => {
          this.getCapabilitiesSuccess(res);
        },
        () => {
          this.getCapabilitiesError();
        },
      );
  }
}
